import { render, staticRenderFns } from "./MerchantForm.vue?vue&type=template&id=76c1bbc2&scoped=true"
import script from "./MerchantForm.vue?vue&type=script&lang=js"
export * from "./MerchantForm.vue?vue&type=script&lang=js"
import style0 from "./MerchantForm.vue?vue&type=style&index=0&id=76c1bbc2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c1bbc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c1bbc2')) {
      api.createRecord('76c1bbc2', component.options)
    } else {
      api.reload('76c1bbc2', component.options)
    }
    module.hot.accept("./MerchantForm.vue?vue&type=template&id=76c1bbc2&scoped=true", function () {
      api.rerender('76c1bbc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rs/merchant/components/MerchantForm.vue"
export default component.exports